const NarrationTypeEnum = {
  noAudio: 'NO_AUDIO',
  autoGenerated: 'AUTO_GENERATED',
  custom: 'CUSTOM'
};

export { NarrationTypeEnum };
export default NarrationTypeEnum;
